import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IndentForm } from "@/features/indents/IndentForm";
import { INDENT_KINDS, type IndentKind } from "@/features/indents/types";

export const Route = createFileRoute("/_authenticated/indents/edit")({
  component: NewIndentPage,
  validateSearch: (s: Record<string, unknown>) => {
    const k = (s.kind as string) ?? "asset";
    return { kind: (INDENT_KINDS as readonly string[]).includes(k) ? (k as IndentKind) : ("asset" as IndentKind) };
  },
});

function NewIndentPage() {
  const navigate = useNavigate();
  const { kind } = Route.useSearch();
  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <Button variant="ghost" size="sm" onClick={() => navigate({ to: "/indents" })}><ArrowLeft className="mr-1 h-4 w-4" />Back</Button>
      <IndentForm initialKind={kind} />
    </div>
  );
}
